import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import { ReducerAppState, appReducer } from './app.reducer';

export const appFeatureStateName = 'appFeature';

export interface AppState {
  app: ReducerAppState
}

export const appReducers: ActionReducerMap<AppState> = {
  app: appReducer
};

export const getAppFeatureState = createFeatureSelector<AppState>(
  appFeatureStateName
);

export const getShowPlansButton = createSelector(
  getAppFeatureState,
  (state: AppState) => state.app.showPlansButton
);

export const getTourToPlanningMenu = createSelector(
  getAppFeatureState,
  (state: AppState) => state.app.showTourPlanningMenu
);

export const getShowDocHistoryDropdown = createSelector(
  getAppFeatureState,
  (state: AppState) => state.app.showDocHistoryDropdown
);

export const getDocHistory = createSelector(
  getAppFeatureState,
  (state: AppState) => state.app.docHistory
);
